// const base = '';

export const ROUTE_HOME = "/";

export const ROUTE_EVENTS = "/events";
export const ROUTE_POSTER_CHAMPION_SHIP_2023 = "/campeonato_autonomico_aire_libre_2023";
export const ROUTE_POSTER_CHAMPION_SHIP_2024 = "/campeonato_spanya_aire_libre_deportistas_discapacidad_2024";
export const ROUTE_POSTER_CHAMPION_SHIP_2025 = "/campeonato_provincias_valencia_y_castellon_aire_libre_2025";

export const ROUTE_ACTIVITIES = "/activities";

export const ROUTE_CONTACT = "/contact";

export const ROUTE_COVID_RULES = "/covid-rules";